module.exports = __webpack_public_path__ + "ef2e2a0d9dd85cf89526d1f27f8fbbef.woff";